import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={ className } { ...props } xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20V6C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H16C17.1 22 18 21.1 18 20H4Z" fill={ fill || 'currentColor' } />
        <path d="M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill={ fill || 'currentColor' } />
    </svg>

);
